<template>
  <div class="agreement" id="agreement" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="flow_main">
        <h4>{{agreement.title}}</h4>
        <article id="articleDetail" v-html="agreement.content"></article>
      </div>
  </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  //api
  import {articlesDetails} from '@/api/article';
  export default {
    name: 'Agreement',
    components:{
      NavB
    },
    data () {
      return {
        titleChild:[{name:'首頁',src:'HomePage'},{name:null,src:'Agreement'}],
        //协议id
          article:this.$route.query.id,
        //协议列表
        agreement:''
      }
    },
    methods:{
      /*获取协议内容*/
      getAgreement(){
        articlesDetails(this.article).then(res =>{
            this.agreement = res.data;
            this.titleChild[1].name = this.agreement.title;
        })
      }
    },
    created(){
     //协议内容
      this.getAgreement();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
 .agreement{
   .flow_main{
     width: 100%;
     padding: 20px 99px;
     min-height: 750px;
     border: 1px solid #eee;
     margin-bottom: 100px;
     h4{
       font-size: 24px;
       text-align: center;
       margin: 30px 0;
     }
     article{
        line-height: 36px;
        font-size: 18px;
      }
   }
 }
</style>



// WEBPACK FOOTER //
// src/pages/clause/Agreement.vue